import React from 'react';
import { StarIcon } from 'lucide-react';
import { testimonios } from '../data/content';
import { TransformCta } from './CtaButton';
function Stars({
  className = ''
}: {
  className?: string;
}) {
  return <div className={`flex gap-0.5 ${className}`} aria-label="5 de 5 estrellas" data-id="element-222" data-mp="3fyvykbm8vfbm">
      {Array.from({
      length: 5
    }).map((_, i) => <StarIcon key={i} className="h-4 w-4 fill-gold-500 text-gold-500" aria-hidden="true" data-id="element-223" data-mp="3b01g5as6vss1" data-mpi={i} />)}
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white px-4 py-14 sm:px-6 sm:py-20" data-id="element-224" data-mp="31zczs9fbpgbz">
      <div className="mx-auto max-w-4xl" data-id="element-225" data-mp="2x0temb8k08ko">
        <h2 className="text-center font-display text-[26px] font-black leading-tight text-navy-900 sm:text-4xl" data-id="element-226" data-mp="2x1uowdhqwr1c">
          Lo que dicen los profesionales que ya utilizan la Ruta
        </h2>

        <div className="mt-4 flex flex-col items-center" data-id="element-227" data-mp="v9om7cysr3za">
          <Stars data-id="element-228" data-mp="v72fffjqcsi4" />
          <p className="mt-2 text-[13px] font-bold text-navy-900 sm:text-base" data-id="element-229" data-mp="qallu5trhlxn">
            Calificación promedio: 4.9/5
          </p>
          <p className="mx-auto mt-2 max-w-xl text-center text-[13px] leading-relaxed text-navy-800/70 sm:text-[15px]" data-id="element-230" data-mp="h55ai23t7vx3">
            Más de 1.000 profesionales de la salud ya utilizan Ruta Fertilidad Masculina para tomar
            decisiones clínicas con mayor seguridad.
          </p>
        </div>

        <div className="mt-9 grid gap-4 md:grid-cols-3" data-id="element-231" data-mp="c7my21ql2ykc">
          {testimonios.map(t => <figure key={t.nombre} className="flex flex-col rounded-3xl border border-navy-800/10 bg-cream p-5 shadow-card sm:p-6" data-id="element-232" data-mp="zxr0w6vy6uaa">
              <Stars className="mb-3" data-id="element-233" data-mp="q761wicd3nqu" />
              <blockquote className="flex-1 text-[13.5px] leading-relaxed text-navy-900/85 sm:text-[15px]" data-id="element-234" data-mp="q63ckeuottd1">
                “{t.texto}”
              </blockquote>
              <figcaption className="mt-4 flex items-center gap-3 border-t border-navy-800/10 pt-4" data-id="element-235" data-mp="1iv1xtku3xbmk">
                <img src={t.foto} alt={`Retrato de ${t.nombre}`} className="h-12 w-12 shrink-0 rounded-full object-cover" loading="lazy" data-id="element-236" data-mp="1nma6genm4syo" />
                <div className="min-w-0" data-id="element-237" data-mp="1sjfl55ald27k">
                  <p className="text-[13.5px] font-bold text-navy-900 sm:text-[15px]" data-id="element-238" data-mp="1ohayiqik95uf">{t.nombre}</p>
                  <p className="text-[12px] text-navy-800/65 sm:text-[13px]" data-id="element-239" data-mp="1ji7yjkhftptb">{t.pais}</p>
                </div>
              </figcaption>
            </figure>)}
        </div>

        <TransformCta headline="Únete a los +1.000 profesionales que ya la utilizan." data-id="element-240" data-mp="1ekzhxobxttu6" />
      </div>
    </section>;
}